<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <b-card>
          <div slot="header">
            <strong>{{$t('NEWIRDEVICE')}}</strong>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('NAME')">
                <inputvalidation :formerror="formError" name="key"><b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div slot="footer">
            <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
            <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveRow(formData)"><i class="fa fa-dot-circle-o"></i> {{$t('SUBMIT')}}</b-button>
          </div>
        </b-card>
      </div><!--/.col-->
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> {{$t('IRDEVICES')}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('IRCODES')}}</th>
                    <th>{{$t('ASSIGNTOMODULES')}}</th>
                    <th>{{$t('SAVE')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in data.root">
                    <tr>
                      <td>{{item.irDeviceId}}</td>
                      <td><b-form-input type="text" v-model="item.name"></b-form-input></td>
                      <td><router-link class="btn btn-primary" :to="'/irdevices/'+item.irDeviceId"><icon name="rocket"></icon> {{$t('IRCODES')}}</router-link></td>
                      <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="showItem(item)"><icon name="edit"></icon> {{$t('ASSIGNTOMODULES')}}</b-button></td>
                      <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="saveRow(item)"><icon name="save"></icon> {{$t('SAVE')}}</b-button></td>
                      <td><b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.key)"><icon name="ban"></icon> {{$t('DELETE')}}</b-button></td>
                    </tr>
                    <tr v-if="item.shown">
                      <td colspan="4">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="row">
                              <div class="col-sm-12">
                                <b-form-fieldset v-bind:label="$t('MODULES')">
                                  <inputvalidation :formerror="formError" name="modulesSelected">
                                    <b-form-select multiple :select-size="10" value-field="moduleId" text-field="moduleName" v-model="item.modulesSelected" :options="modulesdata.root" class="mb-3"></b-form-select>
                                  </inputvalidation>
                                </b-form-fieldset>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="row">
                              <div class="col-sm-12">
                                <b-button type="reset" size="sm" variant="primary" v-on:click.prevent="saveRow(item)"><icon name="save"></icon> {{$t('SAVE')}}</b-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Api from '@/api/IrDevices'
import ModulesApi from '@/api/Modules'

export default {
  name: 'IrDevices',
  data: function()
  {
    return {
      data: {},
      modulesdata: {},
      formError: {},
      formData:
      {
        key: '',
        value: ''
      },
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      },
      modulepagination:
      {
        query: '',
        currentPage: 1,
        limit: 2000,
        searchTimeout: false
      }
    }
  },
  created: function()
  {
    var me = this;
    me.getData();
    me.getModules();
  },
  methods:
  {
    showItem(item)
    {
      var me = this;
      if(typeof item.shown == 'undefined') me.$set(item, 'shown', true);
      else item.shown = !item.shown;
    },
    getModules: function()
    {
      var me = this;
      ModulesApi.selectRow(me.getModuleParams, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.modulesdata = data;
      });
    },
    saveRow: function(item)
    {
      var me = this;

      if(typeof item.irDeviceId != 'undefined')
      {
        item.id = item.irDeviceId;
        delete(item.irDeviceId);
      }

      Api.save(item, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
          me.getData();
        }
      })
    },
    getData: function()
    {
      var me = this;
      Api.selectRow(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.data = data;
      });
    },
    deleteRow: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          Api.deleteRow({id: id}, function(data)
          {
            if(data.error && data.error == true) me.$notify.error(data.notice);
            else me.$notify.success(data.notice);
            me.getData();
          })
        }
      })
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    },
    getModuleParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.modulepagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
